import fetch from '@/utils/fetch';

let COMMON = {
    getCityData(parentId) {
        return fetch({
            url: '/api/product/city',
            method: 'get',
            params: { parentId }
        });
    },
    getUsersData(areaId,custName){
    	return fetch({
            url: '/api/refData/usrs',
            method: 'get',
            params: { areaId, custName }
        });
    },
    getCreateRelation(distributorId,distributorPwd,syncdbLink,syncCustId,supplierId){
        return fetch({
            url: '/api/refData/create',
            method: 'get',
            params: { distributorId,distributorPwd,syncdbLink,syncCustId,supplierId }
        });
    },
    // 一键绑定 2020/02/14 zgh
    getFastCreateRelation(syncParentCustId, syncdbLink){
        return fetch({
            url: '/api/refData/fastCreate',
            method: 'get',
            params: { syncParentCustId,syncdbLink }
        });
    },
    postRelationData(dbLink, parentMchId, infoId) {
        return fetch({
            url: '/api/refData/quotes',
            method: 'post',
            data: { dbLink, parentMchId, infoId }
        });
    },

    deleteRelationData(dbLink, parentMchId, infoId, newInfoId) {
        return fetch({
            url: '/api/refData/unbind',
            method: 'delete',
            params: { dbLink, parentMchId, infoId, newInfoId }
        })
    },
	// 获取产品类型
	getProTypes(areaId,keyword){
		return fetch({
			url: '/api/product/custProductTypies',
			method:'get',
			params: { areaId,keyword }
		})
	},
	// 获取商户个人信息
	getUserInfo(){
		return fetch({
			url: '/api/mchUser/info',
			method:'get'
		})
	},
	// 获取交易详情列表
	getTransactionDetail(params){
		return fetch({
			url:'/interface/business/fundChangeList',
			method:'post',
			params
		})
	},
    // 导出excel接口
    getTransactionDetailExcel(params){
		return fetch({
			url:'/interface/business/fundChangeListExport',
			method:'post',
			params,
            responseType: 'blob'
		})
	}
}
export { COMMON };


// WEBPACK FOOTER //
// ./src/api/common.js